// These styles are applied globally to any page that renders Chakra components. Modify only when necessary, and with great care.

import { fontFamily } from '@core-ds/primitives';

export default {
   global: {
      '*, *::before, &::after': {
         borderColor: 'gray.300', // Overwrite chakra global
      },
      body: fontFamily.sansSystem,
      svg: {
         display: 'initial', // Overwrite chakra global
      },
   },
};
